module.exports = __webpack_public_path__ + "img/blanks.8cd0ccdc.png";